/* eslint-disable */
import Vue from 'vue'
import _ from 'lodash'
import $ from 'jquery'
import moment from 'moment'

export interface MapHawaComponent {
  [parameterName: string]: Element
}

interface Posisi {
  x: number
  y: number
}

function getTransform(el: SVGElement): Posisi {
  const xforms = el.getAttribute('transform')
  const parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms as string)
  return {
    x: parts ? parseFloat(parts[1]) : 0,
    y: parts ? parseFloat(parts[2]) : 0,
  }
}

function isNumeric(value: string) {
  return /^\d+$/.test(value)
}

class Attributes {
  tag = ''
}

interface AnimationFormat {
  [key: string]: string
  // border?: string
  // visible?: boolean
}

type AnimationCondition = '==' | '!=' | '>' | '<' | '>=' | '<='

interface MoveVertical {
  source: string
  valMin: number
  valMax: number
  yMin: number
  yMax: number
}

interface Animation {
  visible?: boolean
  format: AnimationFormat
  condition: AnimationCondition
  inputs: [string, string]
  moveVertical?: MoveVertical
}

interface Attributes {
  // Nama tag yang akan diproses untuk ditampilkan sebagai value
  tag: string
  // Nama function yang digunakan untuk memformat.
  // saat ini yang tersedia adalah moment
  formatter?: string
  // format
  format?: string
  // Anisami
  animations?: Animation[]
}

// const sample: Attributes = {
//   animations: [
//     {
//       format: { fill: '#00FF00' },
//       condition: '!=',
//       inputs: ['string:STOP', 'stacks[0].parameters.UNIT_STATUS.value'],
//     },
//   ],
// }

function parseAnimationInput(input: string, vue: any): any {
  const items = input.split(':')
  if (items.length > 0) {
    switch (items[0]) {
      case 'string':
        return items[1]
      case 'bool':
      case 'boolean':
        return items[1] == 'true'
    }
  }
  return _.get(vue, input)
}

export default Vue.extend({
  methods: {
    applyModel(elements: NodeListOf<Element>, hModel?: string) {
      elements.forEach((el) => {
        const childsClasss = el.querySelectorAll('[h-model][h-class="true"]')
        const classModel = el.getAttribute('h-model')
        if (!classModel) {
          return
        }

        this.applyModel(
          childsClasss,
          hModel ? `${hModel}.${classModel}` : classModel
        )

        el.querySelectorAll(
          '[h-model]:not([h-class="true" > [h-model]])'
        ).forEach((obj) => {
          // if (obj.parentElement) {
          //   const isChildOfClass = obj.parentElement.getAttribute('h-class')
          //   if (isChildOfClass && isChildOfClass == 'true') {
          //     return
          //   }
          // }

          let objModel = obj.getAttribute('h-model')
          if (!objModel) {
            return
          }

          const objValuePath = hModel
            ? `${hModel}.${classModel}.${objModel}`
            : `${classModel}.${objModel}`
          let objValue = _.get(this, objValuePath, '???')

          if (objModel == 'value' && typeof objValue == 'number') {
            const attrPrecision = obj.getAttribute('h-precision')

            if (attrPrecision && isNumeric(attrPrecision)) {
              const precision = parseInt(attrPrecision)
              objValue = objValue.toFixed(precision)
            } else {
              const precisionPath = hModel
                ? `${hModel}.${classModel}.precision`
                : `${classModel}.precision`
              const precision = _.get(this, precisionPath)
              if (typeof precision == 'number') {
                objValue = objValue.toFixed(precision)
              }
            }
          }
          obj.innerHTML = objValue
        })
      })
    },

    parseFaceplate() {
      const svgComp = document.getElementById('svg_component')
      if (svgComp) {
        const containers = Array.from(svgComp.getElementsByTagName('svg'))
        if (containers.length > 0) {
          containers[0].setAttribute('height', '100%')
          containers[0].setAttribute('width', '100%')
        }
      }

      const linkedObjects = Array.from(document.getElementsByTagName('use'))
      for (const obj of linkedObjects) {
        const refId = obj.getAttribute('xlink:href')
        if (typeof refId != 'string') {
          continue
        }

        const templateElement = document.getElementById(refId.slice(1))
        if (!templateElement) {
          continue
        }

        const innerHTML = templateElement.innerHTML

        const posisiTemplate = getTransform(
          (templateElement as any) as SVGElement
        )
        const posisiObj = getTransform(obj)

        posisiObj.x += posisiTemplate.x
        posisiObj.y += posisiTemplate.y

        obj.setAttribute(
          'transform',
          `translate(${posisiObj.x}, ${posisiObj.y})`
        )
        obj.removeAttribute('width')
        obj.removeAttribute('height')
        obj.removeAttribute('xlink:href')
        obj.innerHTML = innerHTML as string
        obj.outerHTML = obj.outerHTML.replace(/use/g, 'g')
      }
    },

    parseHawaComponents() {
      this.parseFaceplate()
      this.updateObjects()

      // const hawaClass = document.querySelectorAll(
      //   '[h-class]:not([h-class] > [h-class]'
      // )

      // this.applyModel(hawaClass)

      // this.parseHawaObjects()
      // Ambil semua element yang memiliki attribute h-model
      // const hObjects = Array.from(
      //   document.querySelectorAll('[h-model][h-class="true"]')
      // )
      // for (const el of hObjects) {
      //   const parameterName = el.getAttribute('h-model')
      //   if (typeof parameterName != 'string') {
      //     continue
      //   }
      //   const classProperties = Array.from(el.querySelectorAll('[h-model]'))
      //   for (const classProp of classProperties) {
      //     const propName = classProp.getAttribute('h-model')
      //     if (typeof propName != 'string') {
      //       classProp.innerHTML = '????'
      //       continue
      //     }

      //     let innerHTML: any = _.get(
      //       this,
      //       `${parameterName}[${propName}]`,
      //       '####'
      //     )

      //     // TODO: Fix value precision
      //     if (propName == 'value' && typeof innerHTML == 'number') {
      //       const precision = _.get(this, `${parameterName}.precision`)
      //       if (typeof precision == 'number') {
      //         innerHTML = innerHTML.toFixed(precision)
      //       }
      //     }

      //     if (typeof innerHTML == 'number') {
      //       const precision = _.get(this, `${parameterName}.precision`, 2)
      //       innerHTML = innerHTML.toFixed(precision)
      //     }

      //     if (propName == 'nameHTML' || propName == 'engineeringUnitHTML') {
      //       innerHTML = innerHTML
      //         .replace(
      //           /<sup>/g,
      //           '<tspan font-size=".7em" baseline-shift = "super" >'
      //         )
      //         .replace(/<\/sup>/g, '</tspan>')
      //         .replace(/<sub>/g, '<tspan font-size=".7em" dy = "2" >')
      //         .replace(/<\/sub>/g, '</tspan>')
      //     }

      //     classProp.innerHTML = innerHTML
      //   }
      // }
    },

    updateObjects() {
      const hawaObjects = document.querySelectorAll('[hawa]')
      hawaObjects.forEach((object) => {
        const attributesString = object.getAttribute('hawa')
        if (!attributesString) {
          return
        }

        let attributes = new Attributes()
        try {
          attributes = JSON.parse(attributesString)
        } catch (err) {
          return
        }

        if (attributes.tag) {
          let formatedValue: any
          const tagValue = _.get(this, attributes.tag, '????')
          //TODO: Add outside red border for invalid tag
          // if (tagValue == '????'){
          // }

          if (attributes.formatter) {
            switch (attributes.formatter) {
              case 'moment':
                formatedValue = moment(tagValue).format(attributes.format)
                break
            }
          } else if (typeof tagValue == 'number') {
            const tagItems = attributes.tag.split('.')
            if (tagItems[tagItems.length - 1] == 'value') {
              tagItems[tagItems.length - 1] = 'precision'
              const precisionAttr = tagItems.join('.')
              let precision = _.get(this, precisionAttr)
              if (typeof precision == 'number') {
                formatedValue = tagValue.toFixed(precision)
              } else {
                formatedValue = tagValue
              }
            } else {
              formatedValue = tagValue
            }
          } else if (typeof tagValue == 'string') {
            formatedValue = tagValue
          }

          if (formatedValue) {
            object.innerHTML = formatedValue
          }
        }

        if (attributes.animations && Array.isArray(attributes.animations)) {
          for (const animation of attributes.animations) {
            if (typeof animation.condition == 'string') {
              let conditionIsMatch = false

              const input0 = parseAnimationInput(animation.inputs[0], this)
              const input1 = parseAnimationInput(animation.inputs[1], this)

              switch (animation.condition) {
                case '==':
                  conditionIsMatch = input0 == input1
                  break
                case '!=':
                  conditionIsMatch = input0 != input1
                  break
                case '>':
                  conditionIsMatch = input0 > input1
                  break
                case '<':
                  conditionIsMatch = input0 < input1
                  break
                case '>=':
                  conditionIsMatch = input0 >= input1
                  break
                case '<=':
                  conditionIsMatch = animation.inputs[0] <= animation.inputs[1]
                  break
              }

              if (conditionIsMatch) {
                for (const key in animation.format) {
                  $(object).css(key, animation.format[key])
                }
              }

              // Animasi visible
              //
              if (typeof animation.visible == 'boolean') {
                if (animation.visible == conditionIsMatch) {
                  $(object).attr('visibility', 'visible')
                } else {
                  $(object).attr('visibility', 'hidden')
                }
              }
            }

            if (typeof animation.moveVertical != 'undefined') {
              const {
                valMax,
                valMin,
                yMax,
                yMin,
                source,
              } = animation.moveVertical

              const value = _.get(this, source)
              if (typeof value != 'number') {
                continue
              }

              if (
                typeof valMax != 'number' ||
                typeof valMin != 'number' ||
                typeof yMax != 'number' ||
                typeof yMin != 'number'
              ) {
                continue
              }

              const currentPosition =
                ((value - valMin) / (valMax - valMin)) * (yMax - yMin) + yMin

              // const rect = object.getBoundingClientRect()
              let actualPos: string
              actualPos = $(object).attr('actual-position') || ''
              if (actualPos == '') {
                // actualPos = `${rect.x},${rect.y}`

                // $(object).attr('transform', `translate(30,${currentPosition})`)
                // console.log(currentPosition)
                let transform = $(object).attr('transform') || '0,0'
                transform = transform.replace('translate(', '').replace(')', '')

                $(object).attr('actual-position', transform)
              }

              // // $(object).attr('transform', `translate(30,${currentPosition})`)
              // console.log(currentPosition)
              // let transform = $(object).attr('transform') || '0,0'
              // transform = transform.replace('translate(', '').replace(')', '')
              const coord = actualPos
                .split(',')
                .map((co: string) => parseFloat(co))
              const x = coord[0]
              const y = coord[1] + currentPosition
              $(object).attr('transform', `translate(${x},${y})`)
              console.log(y)
            }
          }
        }
      })
    },
  },
})
